import { ItemType, MenuItemType } from 'antd/es/menu/interface'
import MainContentLayout from '../../../components/MainContentLayout'
import { PlaylistsRouter, TracksRouter } from '../../../utils/routes/MusicRoutes'

const menu: ItemType<MenuItemType>[] = [
  {
    label: 'All',
    key: 'all',
  },
  {
    label: 'New',
    key: 'new',
  },
]

export default function PlaylistsLayout() {
  return (
    <MainContentLayout
      navigationHeader={{
        headerMenu: menu,
        navigationPrefix: '/music/playlists/',
      }}
    >
      <PlaylistsRouter />
    </MainContentLayout>
  )
}
